var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_422_133116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 52.5H44.8332M55.3332 42C55.3332 42.9283 54.9644 43.8185 54.308 44.4749C53.6517 45.1312 52.7614 45.5 51.8332 45.5H5.1665C4.23825 45.5 3.34801 45.1312 2.69163 44.4749C2.03525 43.8185 1.6665 42.9283 1.6665 42V7C1.6665 6.07174 2.03525 5.1815 2.69163 4.52513C3.34801 3.86875 4.23825 3.5 5.1665 3.5H51.8332C52.7614 3.5 53.6517 3.86875 54.308 4.52513C54.9644 5.1815 55.3332 6.07174 55.3332 7V42ZM36.6665 52.5H20.3332L22.6665 45.5H34.3332L36.6665 52.5Z",
    stroke: "#0B132B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6663 36.1666H6.33301V8.16663H50.6663V36.1666ZM29.6663 40.8333C29.6663 41.1427 29.5434 41.4395 29.3246 41.6583C29.1058 41.877 28.8091 42 28.4997 42C28.1903 42 27.8935 41.877 27.6747 41.6583C27.4559 41.4395 27.333 41.1427 27.333 40.8333C27.333 40.5239 27.4559 40.2271 27.6747 40.0083C27.8935 39.7895 28.1903 39.6666 28.4997 39.6666C28.8091 39.6666 29.1058 39.7895 29.3246 40.0083C29.5434 40.2271 29.6663 40.5239 29.6663 40.8333Z",
    stroke: "#0B132B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_422_133116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc2);
export default __webpack_public_path__ + "static/media/doc2.571aae9cfc0ac13583afda2a4dda4167.svg";
export { ForwardRef as ReactComponent };